<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>

    <div class="form-wrapper">
      <div class="form-navbar">
        <div class="title-nav">
          <label class="col-form-label ml-2 d-none d-sm-block">
            {{form.projectType | capitalize}} Application
          </label>
        </div>
      </div>
      <div class="section-title">
        {{title}}
      </div>
      <div class="row no-gutters">
        <div class="col">
          <router-view :form="form"
                       :val="$v"
                       class="h-100 d-flex align-content-between flex-wrap"
                       v-bind:fetchingData.sync="fetchingData"
                       v-bind:title.sync="title">
          </router-view>
        </div>
        <div class="col-3 d-md-block d-none">
          <div class="save-panel">
            <div class="button-wrapper">
             <button class="btn btn-primary mt-2"
                      v-if="!form.finalized"
                      @click="saveApplication">
                Save And Return Later
              </button>
              <button class="btn btn-danger mt-2"
                      v-if="!form.finalized"
                      @click="completeApplication">
                Submit
              </button>
              <p class="mt-2" v-if="!form.finalized">Clicking Submit indicates you have finalized your entries. You will no longer be able to update recycled quantities for this permit once submitted.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {PermitApplication} from '~/js/FormObjects'
import { DDDValidation } from '@/js/FormValidations'
import { getDDDIApplication, getPrices, capitalize, errorNotification} from '~/js/FormFunctions'
import {CapitalizeFilter} from '@/js/Mixins'

const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

export default {
  name: 'Application',
  props: {
    projectType: {
      validator(value) {
        return ['demolition', 'asbestos'].indexOf(value) !== -1;
      },
    },
  },
  mixins: [CapitalizeFilter],
  data() {
    return {
      form: null,
      title: null,
      currentRoute: 0,
      routes: [
        'materials',
      ],
      permitPrices: [],
      fetchingData: false,
    };
  },
  validations: {
    form: new DDDValidation(),
    pages: {
      materials: ['form.materials']
    }
  },
  mounted () {
    if (this.projectType.toLowerCase() !== 'asbestos') {
      this.routes.splice(this.routes.indexOf('asbestos'), 1);
    }

    this.currentRoute = this.routes.findIndex(route => this.$route.path.endsWith(route));

    // so we can reference it within axios success functions
    const self = this;

    if (this.$store.getters.temporaryForm) {
      this.$set(this, 'form', this.$store.getters.temporaryForm);
      this.$store.commit('temporaryForm', null);
    }

    if (this.$route.query.applicationNumber && !this.form.id) {
      this.fetchingData = true;
      getDDDIApplication(this.$route.query.applicationNumber)
        .then((data) => {
          let materialForm = data
          if (!materialForm.projectType) {
            materialForm.projectType = capitalize(self.projectType)
          }
          self.$set(self, 'form', materialForm)
          self.fetchingData = false
        })
        .catch(() => {
          self.$router.push({ name: 'PermitSearch', params: { projectType: self.projectType } });
          self.fetchingData = false;
        });
    }
  },
  validations: {
    form: new DDDValidation(),
    pages: {
      materials: ['form.materials']
    }
  },
  methods: {
    saveApplication: function () {
      const self = this
      this.mySaveApplication()
        .then((response) => {
          self.$router.push({
            name: 'DDDIApplicationSaved',
            params: {
              projectType: self.projectType.toLowerCase(),
              finalized: false,
            },
            query: {
              applicationId: response.data,
            },
          });
        })
        .catch(() => {});
    },
    completeApplication: function () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        this.$notify('Errors during application validation.', 'error')
        return
      }
      const self = this
      this.myCompleteApplication()
        .then((response) => {
          self.$router.push({
            name: 'DDDIApplicationSaved',
            params: {
              projectType: self.projectType.toLowerCase(),
              finalized: true,
              estimatesFinalized: true,
            },
            query: {
              applicationId: response.data,
            },
          });
        })
        .catch(() => {});
    },
    myCompleteApplication() {
      const self = this;

      const formData = new FormData();

      this.form.materials.forEach((material) => {
        if (material.receiptFile != null) {
          var key = '[MaterialFileUpload] ' + material.uuid
          material.fileKey = key
          formData.append(key, material.receiptFile)
        }
      })
      formData.append('form', JSON.stringify(this.form))
      this.fetchingData = true
      return new Promise((resolve, reject) => {
        self.$http.post('/api/permit/savefinal/materials', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            // console.log(response)
            self.fetchingData = false;
            resolve(response);
          })
          .catch((error) => {
            self.fetchingData = false;
            errorNotification('Error saving application record: ', error);
            reject(error);
          });
      });
    },
    mySaveApplication() {
      const self = this;

      const formData = new FormData();

      this.form.materials.forEach((material) => {
        if (material.receiptFile != null) {
          var key = '[MaterialFileUpload] ' + material.uuid
          material.fileKey = key
          formData.append(key, material.receiptFile)
        }
      });
      this.form.finalized = false;
      formData.append('form', JSON.stringify(this.form));
      this.fetchingData = true;
      return new Promise((resolve, reject) => {
        self.$http.post('/api/permit/saveandreturn/materials', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            // console.log(response)
            self.fetchingData = false;
            resolve(response);
          })
          .catch((error) => {
            self.fetchingData = false;
            errorNotification('Error saving application record: ', error);
            reject(error);
          });
      });
    },
    cancel() {
      this.$router.push({ name: 'PermitApplicationCancel', params: { projectType: this.projectType } });
    },
    cancel: function () {
      this.$router.push({name: 'PermitApplicationCancel', params: {projectType: this.projectType}})
    }
  }
}
</script>
